import React, { createContext, useContext, useMemo } from "react";
import pe from "./pe.json";
import en from "./en.json";
import thankyou from "./thankyou.json";

const dictionaries = { pe, en };

export const SUPPORTED_LANGS = ["pe", "en"];
export const DEFAULT_LANG = "pe";

const I18nContext = createContext({ lang: DEFAULT_LANG, t: (k) => k });

function resolveKey(dict, key) {
  return key.split(".").reduce((acc, part) => (acc && acc[part] != null ? acc[part] : undefined), dict);
}

export function I18nProvider({ lang, children }) {
  const value = useMemo(() => {
    const dict = dictionaries[lang] || dictionaries[DEFAULT_LANG];
    const t = (key) => {
      const val = resolveKey(dict, key);
      if (val === undefined) return key;
      return val;
    };
    return { lang, t };
  }, [lang]);
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}

export function getThankYouCopy() {
  return thankyou.thankYou;
}
